import { Injectable } from '@angular/core';
import { CardStates, CustomProduct, StockLevelStatus } from '@product/const';

@Injectable({
  providedIn: 'root',
})
export class ProductBuyService {
  getCardState(product?: CustomProduct): CardStates {
    if (product?.unit && product.stock?.stockLevelStatus !== StockLevelStatus.OutOfStock && !product.isArchive) {
      return CardStates.AVAILABLE;
    }

    return CardStates.NOT_AVAILABLE;
  }
}
